module.exports = __webpack_public_path__ + "static/media/contact2@2x.34053785.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/contact2@2x.png
// module id = ./src/assets/Home/contact2@2x.png
// module chunks = 0